import React from 'react';
import { ConfirmationCheckbox, ConfirmationsCheckboxProps } from '../../TableComponents/Confirmations/ConfirmationCheckbox';
import { useSelector } from 'react-redux';
import { useWatch } from 'react-hook-form';
import { selectEditableFields } from 'store/redux-store/placement-summary/selectors';

export const OfferConfirmationCheckbox = (props: ConfirmationsCheckboxProps) => {
  const { transportationChosen: defaultTransportationChosen } = useSelector(selectEditableFields);
  const currentTransportationChosen = useWatch({ name: 'transportationChosen' });

  function preventDefaultFallback() {
    // `?? null` treats undefined as null
    const transportationChangedFromDefault =
      (defaultTransportationChosen?.transportationId ?? null) !==
      (currentTransportationChosen?.transportationId ?? null);

    return transportationChangedFromDefault;
  }

  return (
    <ConfirmationCheckbox
      {...props}
      preventDefaultFallback={preventDefaultFallback}
    />
  );
};